import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { getLang, addLangListener, removeLangListener } from '@ds/base';
export var useHtmlLang = function useHtmlLang() {
  var _useState = useState(getLang()),
      _useState2 = _slicedToArray(_useState, 2),
      currentLocale = _useState2[0],
      setCurrentLocale = _useState2[1];

  useEffect(function () {
    var langListener = function langListener(locale) {
      setCurrentLocale(locale);
    };

    addLangListener(langListener);
    return function () {
      return removeLangListener(langListener);
    };
  }, []);
  return currentLocale || null;
};